import React, { useRef, useState } from 'react';
import { FC } from 'react';
import { useDispatch } from 'react-redux';
import { Icons } from '@components/Icon';
import IconTemplate from '@components/Icon';
import { ModalTypes } from '@components/Modal/Modal';
import useTranslations from '@hooks/useTranslation';
import { openModalType } from '../../store/ui';
import ContentTemplate from '../../ui/Content/Content';
import {
    Description,
    ErrorMessage,
    Icon,
    Input,
    InputButton,
    InputSection,
    Link,
    Section,
    Social,
    SuccessMessage,
} from './Newsletter.elements';

export interface NewsletterProps {
    isStaticBanner?: boolean;
    renderOnlyInput?: boolean;
}

const NewsletterTemplate: FC<NewsletterProps> = ({ isStaticBanner = false, renderOnlyInput = false }) => {
    const { t } = useTranslations();

    const dispatch = useDispatch();

    const emailInputRef = useRef<HTMLInputElement>();

    const renderInput = () => (
        <InputSection onClick={() => dispatch(openModalType({ type: ModalTypes.NEWSLETTER }))}>
            <Input ref={emailInputRef} placeholder={t('homepage.newsletter.placeholder')} />
            <InputButton>
                <IconTemplate name={Icons.Send} width={30} height={30} />
            </InputButton>
        </InputSection>
    );

    return renderOnlyInput ? (
        renderInput()
    ) : (
        <ContentTemplate withPadding>
            <Section isStaticBanner={isStaticBanner}>
                <Description>{t('homepage.newsletter.title')}</Description>
                <Description
                    isStaticBanner={isStaticBanner}
                    dangerouslySetInnerHTML={{ __html: t('homepage.newsletter.description') }}
                />
                {renderInput()}
                <Social>
                    <Link target="_black" href="https://www.facebook.com/FiremniVzdelavaniStudioW">
                        <Icon isStaticBanner={isStaticBanner} name={Icons.Facebook} />
                    </Link>
                    <Link target="_black" href="https://www.linkedin.com/company/studio-w">
                        <Icon isStaticBanner={isStaticBanner} name={Icons.Linkedin} />
                    </Link>
                    <Link target="_black" href="https://www.instagram.com/studiow_vzdelavani">
                        <Icon isStaticBanner={isStaticBanner} name={Icons.Instagram} />
                    </Link>
                </Social>
            </Section>
        </ContentTemplate>
    );
};

export default NewsletterTemplate;
